export default "__VITE_ASSET__C5i6WwJE__"